/* Mobile layout only. Existing Impulse and Judge.me controls are reused. */
(function () {
  'use strict';
  var media = window.matchMedia('(max-width: 768px)');
  var priceBlock = null;
  var priceMarker = null;
  var skuSource = null;
  var skuObserver = null;
  var blockObserver = null;
  var blockRoot = null;
  var queued = false;

  function updateSku() {
    var target = document.querySelector('.redcamp-default-pdp [data-rc-mobile-sku]');
    if (!target || !skuSource) return;
    var value = skuSource.textContent.trim();
    var label = value ? '#' + value : '';
    if (target.textContent !== label) target.textContent = label;
    target.hidden = !value;
  }

  function syncSku(root) {
    var current = root.querySelector('[data-sku]');
    if (current === skuSource) return;
    if (skuObserver) skuObserver.disconnect();
    skuSource = current;
    if (skuSource) {
      skuObserver = new MutationObserver(updateSku);
      skuObserver.observe(skuSource, { childList: true, subtree: true, characterData: true });
      updateSku();
    }
  }

  function movePrice(root) {
    var blocks = root.querySelector('[data-product-blocks]');
    if (!blocks) return;
    var price = blocks.querySelector('.product-block--price');
    if (!price) return;
    if (priceBlock !== price) {
      priceBlock = price;
      priceMarker = document.createComment('REDCAMP original price position');
      price.parentNode.insertBefore(priceMarker, price);
    }
    if (!media.matches) {
      if (priceMarker && priceMarker.parentNode && price.previousSibling !== priceMarker) {
        priceMarker.parentNode.insertBefore(price, priceMarker.nextSibling);
      }
      return;
    }
    var badge = blocks.querySelector('.jdgm-prev-badge, .jdgm-preview-badge');
    if (!badge) return;
    var ratingBlock = badge;
    while (ratingBlock.parentElement && ratingBlock.parentElement !== blocks) {
      ratingBlock = ratingBlock.parentElement;
    }
    if (ratingBlock.parentElement !== blocks || ratingBlock === price) return;
    ratingBlock.classList.add('rc-mobile-rei-rating-block');
    if (price.previousElementSibling !== ratingBlock) {
      blocks.insertBefore(price, ratingBlock.nextSibling);
    }
  }

  function apply() {
    var root = document.querySelector('.redcamp-default-pdp');
    if (!root) return;
    syncSku(root);
    var blocks = root.querySelector('[data-product-blocks]');
    if (blocks && blocks !== blockRoot) {
      if (blockObserver) blockObserver.disconnect();
      blockRoot = blocks;
      blockObserver = new MutationObserver(schedule);
      blockObserver.observe(blockRoot, { childList: true, subtree: true });
    }
    movePrice(root);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }

  function init() {
    schedule();
    if (media.addEventListener) media.addEventListener('change', schedule);
    else media.addListener(schedule);
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* Separate navigation buttons reuse the theme's existing Flickity instance.
   Buttons sit outside the slide track, so touch swiping remains unchanged. */
(function () {
  'use strict';

  function addGalleryArrows() {
    document.querySelectorAll('.redcamp-default-pdp [data-product-images][data-has-slideshow="true"]').forEach(function (gallery) {
      var holder = gallery.querySelector('.product__main-photos');
      var slider = holder && holder.querySelector('[data-product-photos]');
      if (!slider || holder.querySelector('.rc-gallery-arrow')) return;

      ['prev', 'next'].forEach(function (direction) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'rc-gallery-arrow rc-gallery-arrow--' + direction;
        button.setAttribute('aria-label', direction === 'prev' ? 'Previous product image' : 'Next product image');
        if (slider.id) button.setAttribute('aria-controls', slider.id);
        button.innerHTML = direction === 'prev'
          ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4 7 12l8 8"/></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 4 8 8-8 8"/></svg>';
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var currentSlider = holder.querySelector('[data-product-photos]');
          var flickity = currentSlider && window.Flickity && window.Flickity.data(currentSlider);
          if (!flickity || !flickity.slides || flickity.slides.length < 2) return;
          if (direction === 'prev') flickity.previous();
          else flickity.next();
        });
        holder.appendChild(button);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addGalleryArrows, { once: true });
  } else {
    addGalleryArrows();
  }
  document.addEventListener('shopify:section:load', addGalleryArrows);
})();


/* REDCAMP product rating badge -> Judge.me Reviews section (desktop + mobile). */
(function () {
  'use strict';

  var badgeSelector = '.redcamp-default-pdp [data-product-blocks] .jdgm-preview-badge, ' +
    '.redcamp-default-pdp [data-product-blocks] .jdgm-prev-badge';

  function findReviewsSection() {
    // Keep the original Judge.me app section. It is moved below the details
    // section by the existing mobile accordion; do not create a second widget.
    var widget = document.querySelector('#judgeme_product_reviews');
    if (widget) return widget.closest('.shopify-section') || widget;
    return document.querySelector('.shopify-section[id$="__16802429123704a4c4"]');
  }

  function goToReviews(event) {
    if (!event.target || !event.target.closest) return;
    var badge = event.target.closest(badgeSelector);
    if (!badge) return;

    var reviewsSection = findReviewsSection();
    if (!reviewsSection || reviewsSection.contains(badge)) return;

    // Judge.me may attach its own click handler to the preview badge.
    // Override navigation only for this product's badge, not the review widget.
    event.preventDefault();
    event.stopImmediatePropagation();

    if (window.matchMedia('(max-width: 768px)').matches &&
        reviewsSection.classList.contains('rc-mobile-review-section')) {
      var toggle = reviewsSection.querySelector(':scope > .rc-mobile-review-toggle');
      if (toggle && toggle.getAttribute('aria-expanded') !== 'true') {
        toggle.click(); // Reuse the existing accordion state and rating logic.
      }
    }

    requestAnimationFrame(function () {
      if (!reviewsSection.isConnected) return;
      reviewsSection.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  }

  // Delegation handles async Judge.me rendering and Shopify editor rerenders.
  document.addEventListener('click', goToReviews, true);
})();
